import api from '../api/api';

/**
 * Get user profile data
 * @returns {Promise} Promise that resolves to user profile data
 */
export const getUserProfile = async () => {
  try {
    const response = await api.get('/settings/profile');
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

/**
 * Update user profile
 * @param {Object} profileData - Data to update profile with
 * @returns {Promise} Promise that resolves to updated user profile
 */
export const updateUserProfile = async (profileData) => {
  try {
    const response = await api.put('/settings/profile', profileData);
    return response.data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

/**
 * Change user password
 * @param {Object} passwordData - Object with currentPassword and newPassword
 * @returns {Promise} Promise that resolves to API response
 */
export const changePassword = async (passwordData) => {
  try {
    const response = await api.post('/settings/change-password', passwordData);
    return response.data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
};

/**
 * Get notification settings
 * @returns {Promise} Promise that resolves to notification settings
 */
export const getNotificationSettings = async () => {
  try {
    const response = await api.get('/settings/notifications');
    return response.data;
  } catch (error) {
    console.error('Error fetching notification settings:', error);
    throw error;
  }
};

/**
 * Update notification settings
 * @param {Object} settingsData - Settings data to update
 * @returns {Promise} Promise that resolves to updated notification settings
 */
export const updateNotificationSettings = async (settingsData) => {
  try {
    const response = await api.put('/settings/notifications', settingsData);
    return response.data;
  } catch (error) {
    console.error('Error updating notification settings:', error);
    throw error;
  }
};

/**
 * Get user preferences (theme, language, etc.)
 * @returns {Promise} Promise that resolves to user preferences
 */
export const getUserPreferences = async () => {
  try {
    const response = await api.get('/settings/preferences');
    return response.data;
  } catch (error) {
    console.error('Error fetching user preferences:', error);
    throw error;
  }
};

/**
 * Update user preferences
 * @param {Object} preferencesData - Preferences data to update
 * @returns {Promise} Promise that resolves to updated user preferences
 */
export const updateUserPreferences = async (preferencesData) => {
  try {
    const response = await api.put('/settings/preferences', preferencesData);
    return response.data;
  } catch (error) {
    console.error('Error updating user preferences:', error);
    throw error;
  }
};

const settingsService = {
  getUserProfile,
  updateUserProfile,
  changePassword,
  getNotificationSettings,
  updateNotificationSettings,
  getUserPreferences,
  updateUserPreferences
};

export default settingsService;